import { Moment } from 'moment';
import React from 'react';
import { isSameDay, isSameMonth, getYear } from 'date-fns';
import { formatDate } from '../../../../utils/dateUtils';

type Props = {
  startDate: Moment;
  endDate: Moment;
};

const AbsenceDateDuration: React.FC<React.PropsWithChildren<Props>> = ({
  startDate,
  endDate,
}) => {
  const startDateObj = startDate.toDate();
  const endDateObj = endDate.toDate();
  const currentYear = getYear(new Date());

  const monthFormat =
    getYear(startDateObj) === currentYear && getYear(endDateObj) === currentYear
      ? 'MMMM'
      : 'MMMM yyyy';

  if (isSameDay(startDateObj, endDateObj)) {
    return <>{formatDate(startDateObj, `d ${monthFormat}`)}</>;
  } else if (isSameMonth(startDateObj, endDateObj)) {
    return (
      <>
        {formatDate(startDateObj, 'd')}
        &nbsp;-&nbsp;
        {formatDate(endDateObj, 'd')}
        &nbsp;
        {formatDate(startDateObj, monthFormat)}
      </>
    );
  } else {
    return (
      <>
        {formatDate(startDateObj, `dd ${monthFormat}`)}
        &nbsp;-&nbsp;
        {formatDate(endDateObj, `dd ${monthFormat}`)}
      </>
    );
  }
};

export default AbsenceDateDuration;
